var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinEstateOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C22.8701 0 29.25 6.37994 29.25 14.25C29.25 21.0341 24.5093 26.7109 18.1599 28.1484L15.7623 31.4058C15.4349 31.8506 14.8089 31.9458 14.3642 31.6184C14.283 31.5587 14.2113 31.487 14.1516 31.4058L11.736 28.1244C5.43897 26.6488 0.75 20.997 0.75 14.25C0.75 6.37994 7.12994 0 15 0Z",
    fill: "#CF1427"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.2104C22 20.6465 21.6518 21 21.2222 21H8.77778C8.34823 21 8 20.6465 8 20.2104V11.7727C8 11.5309 8.1091 11.3025 8.29606 11.1527L14.5183 6.16967C14.8007 5.94344 15.1993 5.94344 15.4817 6.16967L21.7039 11.1527C21.8909 11.3025 22 11.5309 22 11.7727V20.2104Z",
    fill: "#ECF5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEstateOffline);
export default __webpack_public_path__ + "static/media/pin-estate-offline.d1436c7da88bc7967fce367ba64260db.svg";
export { ForwardRef as ReactComponent };